module.exports = __webpack_public_path__ + "img/VerTrailer-icon-01.f8874a4f.svg";